import { createRoot } from 'solid-js';
import { getOverlayMount } from '../../../../lib/overlay-mount';
import { ActionSheet } from './Component';
import './style.css';

export { ActionSheetCheckIcon } from './CheckIcon';

interface Props {
  content: any;
  title?: any;
  /** 追加到 .action-sheet-content，避免依赖 :has() 做布局 */
  contentClass?: string;
  zIndex?: number;
  /** 返回 false 时点遮罩也不关。密码提交中用来锁层 */
  canClose?: () => boolean;
  /** 层真正关掉后回调（下滑 / 遮罩 / close()） */
  onClose?: () => void;
}

/** 关层选项：跳转前关层请传 skipHistoryBack，避免 back 冲掉 routeTo */
export type ActionSheetCloseOptions = {
  skipHistoryBack?: boolean;
};

export interface API {
  handleClose: (options?: ActionSheetCloseOptions) => void;
}

export const showActionSheet = (props: Props) => {
  const { content, title, contentClass, zIndex, canClose, onClose } = props;
  let api = {} as API;
  createRoot((dispose) => {
    const mount = getOverlayMount();

    const close = () => {
      if (actionSheet.parentNode === mount) {
        mount.removeChild(actionSheet);
      }
      dispose();
      onClose?.();
    };

    let actionSheet = ActionSheet({
      zIndex,
      content,
      contentClass,
      title,
      canClose,
      close,
      api,
    }) as any;

    mount.appendChild(actionSheet);
  });

  return {
    close: (options?: ActionSheetCloseOptions) => api.handleClose(options),
  };
};
